import { render, staticRenderFns } from "./contract-customer-form.vue?vue&type=template&id=df535fc0&scoped=true&"
import script from "./contract-customer-form.vue?vue&type=script&lang=js&"
export * from "./contract-customer-form.vue?vue&type=script&lang=js&"
import style0 from "./contract-customer-form.vue?vue&type=style&index=0&id=df535fc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df535fc0",
  null
  
)

export default component.exports